// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"4b67a552","453":"35ff00e3","706":"17d986d7","813":"21d5ec0d"}[chunkId] + ".chunk.js";
};